import React from 'react';
import { Box } from '@tapresearch/ui/components';
import { Virtuoso } from 'react-virtuoso';
export var FreeTextAnswersList = function(param) {
    var _param_answers = param.answers, answers = _param_answers === void 0 ? [] : _param_answers;
    return /*#__PURE__*/ React.createElement(Box, {
        w: "full",
        my: 6
    }, /*#__PURE__*/ React.createElement(Virtuoso, {
        style: {
            height: '400px'
        },
        totalCount: answers.length,
        itemContent: function(index) {
            return /*#__PURE__*/ React.createElement(Box, {
                borderBottom: "1px solid",
                borderColor: "gray.200",
                py: 5,
                px: 2
            }, answers[index]);
        }
    }));
};
